import { fetchData } from '../../../helpers/base_data_fetcher';

export default {
  getPhotos: () => fetchData('page.photos'),
  getVideo: () => fetchData('page.video'),
};
